import Vue from 'vue';
import VueCookies from 'vue-cookies';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

import '../src/assets/scss/elements.css'

import ComponentLoader from './component-loader';
import mixin from './mixin';

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueCookies);
Vue.mixin(mixin);

ComponentLoader.loadComponents();
